<template>
  <pages-wrapper>
    <div class="about-page">
      <h1 class="about-title">
        {{ pageTitle }}
      </h1>

      <div v-html="PAGE_CONTENT" />
    </div>
  </pages-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PagesWrapper from '@/components/info-pages/pages-wrapper';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'about',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data: () => ({
    pageTitle: 'О бренде',
  }),

  computed: {
    ...mapGetters({
      PAGE_CONTENT: 'staticPages/page'
    })
  },

  methods: {
    ...mapActions({
      LOAD_PAGE: 'staticPages/loadStaticPage'
    })
  },

  serverPrefetch() {
    return this.LOAD_PAGE();
  }
};
</script>

<style lang="scss">
.about-page {
  .banner {
    margin-bottom: 24px;
  }
}

@include breakpoint("desktop") {
  .about-page {
    .banner {
      margin-top: 32px;
    }
  }
}
</style>
